import React, { ReactElement, cloneElement } from 'react';

import { Space, Text, Title, useMantineTheme } from '@mantine/core';
import { SmartAssistantVisualConfig } from 'shared/interfaces/SmartAssistant';
import { MFlex, MFlexProps } from 'shared/motion/MFlex';

export interface ChatWelcomeHeaderProps extends MFlexProps {
  avatar: ReactElement;
  smartAssistantVisualConfig: SmartAssistantVisualConfig;
  title?: string;
  subtitle?: string;
}

export function ChatWelcomeHeader({
  avatar,
  smartAssistantVisualConfig,
  title,
  subtitle,
  ...flexProps
}: ChatWelcomeHeaderProps) {
  const theme = useMantineTheme();

  const { conversationBackgroundColor } = smartAssistantVisualConfig;

  const titleColor = theme.other.getReadableColor(conversationBackgroundColor);
  const subtitleColor = theme.other.getSecondaryReadableColor(conversationBackgroundColor);

  return (
    <MFlex direction="column" align="center" maw={300} w="100%" {...flexProps}>
      {avatar && cloneElement(avatar, { size: 60, radius: 30 })}
      <Space h="xs" />
      <Title fz="1.75rem" align="center" c={titleColor}>
        {title}
      </Title>
      <Text color={subtitleColor} align="center">
        {subtitle}
      </Text>
    </MFlex>
  );
}
